import conf from 'conf/config';

const route_to_full_url = (rel) =>
{
    if(Object.keys(conf.route).includes(rel))
    {
        return `${conf.route.base}/${conf.route[rel]}`;
    }
    else
    {
        return "INVALID_URL";
    }
};

const deep_clone_obj = (obj) =>
{
    return JSON.parse(JSON.stringify(obj))
};

const check_if_email = (str) =>
{
    // Regular expression to check if string is email
    const regexExp = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,63}$/g;

    return regexExp.test(str);
};

function ASCIIValid(_str, ascii_min = 33, ascii_max = 126)
{
    if (!(ascii_min >= 0 && ascii_min <= 255)) throw new Error('Parameter is not in a valid range!');
    if (!(ascii_min >= 0 && ascii_min <= 255)) throw new Error('Parameter is not in a valid range!');
    for (let i = 0; i < _str.length; i++)
    {
        const _char = _str.charCodeAt(i);
        if (_char > ascii_max || _char < ascii_min)
        {
            return false;
        }
    }
    return true;
}
export
{
    route_to_full_url,
    check_if_email,
    deep_clone_obj,
    ASCIIValid
};
